/**
 * Created by lxj on 2020/7/9.
 * 用于打版配置的私有配置，会和conf.js合并
 */

// 全局变量
export default {}
